import { isEmpty } from 'lodash';

const checkShowAllFields = (formField) => {
  return !isEmpty(formField?.brand) && !isEmpty(formField?.type);
};

export default checkShowAllFields;
